module.exports = __webpack_public_path__ + "img/arrow-big-purple.e0a311b7.png";